<template>
  <router-link
    :to="{ name: 'article_view', params: { id: item.id } }"
    :target="linkTarget"
    class="article-item-component"
  >
    <component :is="view" :item="item" :size="size" :theme="theme"></component>
  </router-link>
</template>

<script>
import ArticleNormalCard from './ArticleNormalCard'
import ArticleSimpleCard from './ArticleSimpleCard'
import ArticleLineCard from './ArticleLineCard'

export default {
  components: {
    ArticleNormalCard,
    ArticleLineCard,
    ArticleSimpleCard
  },
  props: {
    type: {
      validator(value) {
        /**
         * 展示类型：
         * simple-card：左右布局，使用位置：首页中的最新资讯
         * line-card：左右布局，展示desc，使用位置：案例榜单列表
         * normal-card: 上下布局，使用位置：行业资讯列表，推荐...
         */
        return ['simple-card', 'line-card', 'normal-card'].includes(value)
      },
      default: 'normal-card'
    },
    item: {
      type: Object,
      default: () => ({})
    },
    size: {
      validator(value) {
        return ['small', 'normal'].includes(value)
      },
      default: 'normal'
    },
    theme: { type: String, default: 'normal' },
    // 是否需要在新tab页打开
    linkTarget: { type: String, default: '_seft' }
  },
  computed: {
    view() {
      return `article-${this.type}`
    }
  }
}
</script>

<style lang="scss" scoped>
.article-item-component {
  color: $text-color-default;
}
</style>
